// Copyright (c) StrangeBee 2024

import { generateId } from '@Helpers/string';
import React, { ReactElement, ReactNode, useRef } from 'react';
import { useDrag } from 'react-dnd';

interface ReportDropableItemProps {
    children: ReactNode;
    rowIndex: number;
    id: string;
    disabled?: boolean;
    onDrop: (item: any) => void;
}

export const ReportDropableItem = ({
    children,
    id,
    rowIndex,
    disabled,
    onDrop,
}: ReportDropableItemProps): ReactElement => {
    const ref = useRef<HTMLDivElement>(null);

    const [, drag] = useDrag({
        item: {
            type: 'report-list',
            id,
            index: rowIndex,
            dragId: generateId(),
        },
        end: (_, monitor) => {
            onDrop(monitor.getItem());
        },
        canDrag: !disabled,
    });

    drag(ref);

    return <span ref={ref}>{children}</span>;
};
